// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_96X","cls2":"common-cls2_qry common-cls1_96X"};